__turbopack_context__.v({
  "card": "_N8Ddq_card",
  "container": "_N8Ddq_container",
  "variant--standard": "_N8Ddq_variant--standard",
  "variant--wideCard": "_N8Ddq_variant--wideCard",
});
